module.exports = __webpack_public_path__ + "img/loader.c2d21f8d.svg";